<template>
	<div class="visa-total">
		<img src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/pc/qqqz_tt%402x.png" class="title-icon-1" />
		<div class="content">
			<img src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/pc/img_qzlc%402x.png" class="title-icon-2" />

			<div class="product-bar">
				<HomeTitleBar :type="Number('11')" title="热门签证" desc="热  门  推   荐" :tab_array="[]"></HomeTitleBar>
				<div class="product-more-bar">
					<HomeVisaItem v-for="(item, index) in product_visa" :index="index" :key="item.id"
						:img_src="item.picturePath" :title="item.title" :send_place="item.cfd" :price="item.refPrice"
						:desc="item.strengths" @clickProductItem="clickProductItem(item.id)">
					</HomeVisaItem>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getVisaMainNew
	} from "@/api/index";
	import HomeVisaItem from "../components/Home_Visa_Item.vue";
	import HomeTitleBar from "../components/Home_Title_Bar.vue";
	export default {
		components: {
			HomeTitleBar,
			HomeVisaItem,
		},
		data() {
			return {
				product_visa: [],

			};
		},
		created() {
			this.getVisaMain();
		},
		methods: {
			clickArea(id, name) {
				let org = this.$route.query.org ? this.$route.query.org : ''
				window.open(
					"/VisaMoreProduct?areaid=" + id + "&areaname=" + name + "&tab_name=7&org=" + org,
					"_blank"
				);
			},
			clickProductItem(id) {
				let org = this.$route.query.org ? this.$route.query.org : ''
				window.open(
					"/VisaDetail?id=" + id + "&tab_name=7&org=" + org,
					"_blank"
				);
			},
			getVisaMain() {
				let platformid;
				if (this.$app == "dy") platformid = "8";
				else if (this.$app == "kh") platformid = "7";
				getVisaMainNew(1, 8, platformid).then((res) => {
					console.log(res)
					res.objects.forEach(ele => {
						console.log(JSON.parse(ele.pd_json))
						ele.pd_json = JSON.parse(ele.pd_json)
						ele.cfd = ''
						if (ele.pd_json != "") {
							ele.pd_json.pod.forEach((le, i) => {
								if (i + 1 == ele.pd_json.pod.length) {
									ele.cfd = ele.cfd + le.Pod
								} else {
									ele.cfd = ele.cfd + le.Pod + '、'
								}
							})
						}
						ele.strengths = ele.strengths.map(item => (item.strength)).join("、")
						ele.refPrice = ele.refPrice + ''
					})
					this.product_visa = res.objects;
				});
			},
		},
	};
</script>

<style lang='less' scoped>
	.visa-total {
		display: flex;
		width: 100vw;
		flex-direction: column;
		align-items: center;
		background-color: #fff;

		.title-icon-1 {
			width: 100%;
		}

		.content {
			width: 1200px;
			padding-bottom: 100px;

			.title-icon-2 {
				margin-top: 20px;
				margin-bottom: 20px;
				width: 100%;
			}

			.hot-place-icon {
				width: 285px;
				height: 200px;
				cursor: pointer;
				margin-bottom: 20px;
			}

			.product-bar {
				display: flex;
				z-index: 1;
				width: 1200px;
				flex-direction: column;

				.product-more-bar {
					display: flex;
					width: 100%;
					flex-wrap: wrap;
					justify-content: space-between;
				}
			}
		}
	}
</style>